import { Link } from "react-router-dom";
import { DataSciLogo } from "./DataSciLogo";

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="container" style={{ paddingTop: "var(--space-6)", paddingBottom: "var(--space-6)" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "var(--space-3)", marginBottom: "var(--space-4)" }}>
          <Link to="/" aria-label="DataSci Editora — página inicial"><DataSciLogo small /></Link>
        </div>
        <p className="text-muted" style={{ fontSize: "var(--text-sm)", marginBottom: "var(--space-2)" }}>
          LONDON SIM GESTÃO DE DOCUMENTOS LTDA — CNPJ 22.390.588/0001-70 — contato@datasci.com.br
        </p>
        <p className="text-muted" style={{ fontSize: "var(--text-xs)" }}>
          Payments by Universal Pagamentos S/A.
        </p>
        <nav aria-label="Links rápidos e legais" className="site-footer__legal">
          <Link to="/resgatar" style={{ fontWeight: 600, color: "var(--color-brass)" }}>Resgatar Livro por Código</Link>
          <Link to="/catalogo">Catálogo</Link>
          <Link to="/login">Entrar</Link>
          <Link to="/legal/privacidade">Privacidade</Link>
          <Link to="/legal/cookies">Cookies</Link>
          <Link to="/legal/termos">Termos de Uso</Link>
          <Link to="/legal/licenca-individual">Licença Individual</Link>
          <Link to="/legal/licenca-corporativa">Licença Corporativa</Link>
          <Link to="/legal/reembolso">Reembolso</Link>
          <Link to="/legal/contato">Contato</Link>
        </nav>
      </div>
    </footer>
  );
}
